import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductMinMaxAlert } from "src/models/Products/Product.models";

interface ProductMinMaxAlertState {
  productAlerts: IProductMinMaxAlert[];
  productAlertToEdit: IProductMinMaxAlert | null;
}

const initialState: ProductMinMaxAlertState = {
  productAlerts: [],
  productAlertToEdit: null,
};

const productMinMaxAlertSlice = createSlice({
  name: "ProductMinMaxAlert",
  initialState,
  reducers: {
    setProductMinMaxAlertList: (state, action: PayloadAction<IProductMinMaxAlert[]>) => {
      state.productAlerts = action.payload;
    },
    concatListProductMinMaxAlert: (state: ProductMinMaxAlertState, action: PayloadAction<IProductMinMaxAlert[]>) => {
      state.productAlerts = [...state.productAlerts.concat(action.payload)];
    },
    setProductMinMaxAlertToEdit: (state, action: PayloadAction<IProductMinMaxAlert | null>) => {
      state.productAlertToEdit = action.payload;
    },
    addProductMinMaxAlert: (state, action: PayloadAction<IProductMinMaxAlert>) => {
      state.productAlerts.push(action.payload);
    },
    updateProductMinMaxAlert: (state, action: PayloadAction<IProductMinMaxAlert>) => {
      let itemIndex = state.productAlerts.findIndex(
        item => item.alertId === action.payload.alertId
      );
      if (itemIndex !== -1) state.productAlerts[itemIndex] = action.payload;
    },
    deleteProductMinMaxAlert: (state, action: PayloadAction<number>) => {
      const newArray = state.productAlerts.filter(item => item.alertId !== action.payload);
      state.productAlerts = newArray;
    },
  },
});

export const {
  setProductMinMaxAlertList,
  concatListProductMinMaxAlert,
  setProductMinMaxAlertToEdit,
  addProductMinMaxAlert,
  updateProductMinMaxAlert,
  deleteProductMinMaxAlert,
} = productMinMaxAlertSlice.actions;

export default productMinMaxAlertSlice.reducer;
